import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Less_lg = (props) => {
    const width = props.width ? props.width + 'px' : '32px';
    const height = props.height ? props.height + 'px' : '32px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 32 32"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M29 16C29 16.5523 28.5523 17 28 17L4 17C3.44771 17 3 16.5523 3 16C3 15.4477 3.44771 15 4 15L28 15C28.5523 15 29 15.4477 29 16Z"
            />
        </SvgStyled>
    );
};

export default Less_lg;
